import { ElMessage } from 'element-plus'

import { useAuthStore } from '@/stores/auth'

/**
 * 閒置自動登出：連續 IDLE_LIMIT_MS 沒有任何操作（滑鼠/鍵盤/捲動/觸控）
 * 就登出並導回登入頁。搭配後端 refresh token 12 小時絕對時效
 * （REFRESH_TOKEN_TTL_HOURS）構成完整的 session 管控。
 *
 * - 活動時間戳寫入 localStorage → 多分頁共用（在 A 分頁操作，B 分頁不會誤登出）。
 * - 寫入節流 10 秒一次，滑鼠移動不會狂寫 storage。
 * - 只在已登入狀態觸發；登入表單的輸入本身就是活動，不會登入後被立即踢出。
 */
const IDLE_LIMIT_MS = 30 * 60_000
const ACTIVITY_KEY = 'g365_last_activity'
const WRITE_THROTTLE_MS = 10_000
const CHECK_EVERY_MS = 30_000

export function initIdleLogout(): void {
  let lastWrite = 0
  const touch = (): void => {
    const now = Date.now()
    if (now - lastWrite < WRITE_THROTTLE_MS) return
    lastWrite = now
    try { localStorage.setItem(ACTIVITY_KEY, String(now)) } catch { /* private mode 等 */ }
  }

  const EVENTS: (keyof WindowEventMap)[] = [
    'mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'scroll',
  ]
  for (const ev of EVENTS) {
    // capture: 捲動事件不冒泡，用捕獲才接得到內層容器的捲動。
    window.addEventListener(ev, touch, { passive: true, capture: true })
  }
  touch()

  setInterval(async () => {
    const auth = useAuthStore()
    if (!auth.isAuthenticated) return
    let last = 0
    try { last = Number(localStorage.getItem(ACTIVITY_KEY) || 0) } catch { last = 0 }
    if (!last) { touch(); return }
    if (Date.now() - last <= IDLE_LIMIT_MS) return

    auth.logout()
    ElMessage.warning(`閒置超過 ${IDLE_LIMIT_MS / 60_000} 分鐘，已自動登出`)
    const { router } = await import('@/router')
    if (router.currentRoute.value.name !== 'login') {
      void router.replace({ name: 'login' })
    }
  }, CHECK_EVERY_MS)
}
